import React from "react";
import { formatInteger } from "../../helpers/formatNumber";
import { Loader } from "../Loader";
import { StreamProgress as Progress } from "./useAnalyticsStream";

/**
 * How much of the tab has been gathered.
 *
 * Sections and rows, because those are the only honest units. Postgres reports no
 * progress for an ordinary SELECT — pg_stat_progress_* covers VACUUM, ANALYZE,
 * CREATE INDEX, CLUSTER and COPY, nothing else — so a percentage "within" a query
 * would have to be invented. Splitting the range into days would not help either:
 * the funnels count distinct users and pairs, and those cannot be added up across
 * slices. A section landing is a real event, and its rows are a real number.
 */
const StreamProgress: React.FC<{ progress: Progress }> = ({ progress }) => {
  const { total, done, failed, rows, running } = progress;

  if (total === 0 || (!running && failed === 0)) {
    return null;
  }

  return (
    <div className="flex items-center gap-3 mb-6 text-sm text-gray-600">
      {running && <Loader className="w-4 h-4" />}
      <span>
        Gathered{" "}
        <span className="font-medium text-gray-800">
          {done} of {total}
        </span>{" "}
        sections · {formatInteger(rows)} rows
        {failed > 0 && (
          <span className="text-red-500">
            {" "}
            · {failed} {failed === 1 ? "section" : "sections"} failed
          </span>
        )}
      </span>
    </div>
  );
};

export default StreamProgress;
